// Witcore Suite - Version 1.0.0
// Copyright(c) 2024 Witcore LLC. All rights reserved.

export function protect(fn, arg) {
  if (fn) {
    try {
      return fn(arg);
    }
    catch (err) {
      console.log(err);
      return null;
    }
  }
  else {
    return null;
  }
}
